const AGENDIZE_APP_URL = process.env.REACT_APP_AGENDIZE_APP_URL

export { AGENDIZE_APP_URL }
